module.exports = __webpack_public_path__ + "static/img/2areaB_32.94a6f5b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/2areaB_32.png
// module id = 1144
// module chunks = 1